import { FormControl, InputLabel } from '@mui/material';

interface ICasControl {
  // null renders the control bare, for callers that supply their own label (the SCE data
  // object header puts "Layout" to the left of the select).
  label: string | null;
  children: JSX.Element;
  shrink?: boolean;
  // Stretch to the container instead of sizing to content — the wrapper has to
  // stretch too, or a full-width control inside it is still only as wide as this.
  fullWidth?: boolean;
}

export default function CasControl({ label, children, shrink, fullWidth }: ICasControl) {
  if (label === null) return children;
  return (
    <FormControl
      fullWidth={fullWidth}
      sx={{
        flexShrink: 0,
      }}
    >
      <InputLabel shrink={shrink}>{label}</InputLabel>
      {children}
    </FormControl>
  );
}
